import { render, staticRenderFns } from "./trainResource.vue?vue&type=template&id=231e2894&scoped=true"
import script from "./trainResource.vue?vue&type=script&lang=js"
export * from "./trainResource.vue?vue&type=script&lang=js"
import style0 from "./trainResource.vue?vue&type=style&index=0&id=231e2894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e2894",
  null
  
)

export default component.exports